import axios from "axios";
import { authHeader } from "./headerConfig";
const API_ENDPOINT =
    process.env.REACT_APP_ENDPOINT + "/api/x-admin/payment-infos";

const addPayment = data => {
    return axios.post(API_ENDPOINT, data, {
        withCredentials: true,
        headers: { ...authHeader(), Accept: "application/json" },
    });
};
const getPayment = id => {
    return axios.get(`${API_ENDPOINT}/${id}`, {
        withCredentials: true,
        headers: { ...authHeader(), Accept: "application/json" },
    });
};
const deletePayment = id => {
    return axios.delete(`${API_ENDPOINT}/${id}`, {
        withCredentials: true,
        headers: { ...authHeader(), Accept: "application/json" },
    });
};
const getPayments = async (page = 1) => {
    const response = await axios.get(`${API_ENDPOINT}?page=${page}`, {
        withCredentials: true,
        headers: { ...authHeader(), Accept: "application/json" },
    });
    return response.data;
};
const updatePayment = (data, id) => {
    return axios.put(`${API_ENDPOINT}/${id}`, data, {
        withCredentials: true,
        headers: { ...authHeader(), Accept: "application/json" },
    });
};
const updatePaymentImage = (data, id) => {
    return axios.post(`${API_ENDPOINT}/${id}/image`, data, {
        withCredentials: true,
        headers: { ...authHeader() },
    });
};
const paymentService = {
    addPayment,
    getPayments,
    deletePayment,
    getPayment,
    updatePayment,
    updatePaymentImage,
};

export default paymentService;
